<template>
  <main class="mt-4">
    <trac-loading v-if="isLoading" />
    <main v-show="userForm">
      <div>
        <trac-back-button> <h2 class="text-xs">Settings</h2></trac-back-button>
        <h1 class="font-medium mt-2">Employee Details</h1>
        <div class="mt-6 bg-white grid md:flex w-full white-gradient px-8 py-6">
          <!-- <div>
            <div class="w-64 bg-gray-400 h-56 rounded-tl-sm rounded-tr-sm">
              <img src="" v-if="0" class="w-full h-full object-cover" alt="" />
            </div>
            <div
              class="
                w-64
                flex
                items-center
                justify-center
                py-3
                cursor-pointer
                bg-gray-500
                text-sm text-white
              "
            >
              Add Picture
            </div>
          </div> -->
          <trac-validation-observer slim v-slot="{ handleSubmit }">
            <form
              @submit.prevent="handleSubmit(hideUserForm)"
              class="mt-6 md:mt-0 w-full"
              >
              <!-- class="md:ml-10 mt-6 md:mt-0 md:pl-10 w-full md:border-l" -->
              <trac-custom-header>
                <template slot="leading">Edit</template>
                <template slot="trailing"> User</template>
              </trac-custom-header>
              <div class="grid md:grid-cols-2 col-gap-10 row-gap-8">
                <trac-validation-provider
                  name="first name"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <trac-input
                    v-model="user.first_name"
                    placeholder="First Name"
                    ref="first name"
                  ></trac-input>
                  <trac-input-error v-if="errors[0]">{{
                    errors[0]
                  }}</trac-input-error>
                </trac-validation-provider>

                <trac-validation-provider
                  name="last name"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <trac-input
                    v-model="user.last_name"
                    placeholder="Last Name"
                    ref="last name"
                  ></trac-input>
                  <trac-input-error v-if="errors[0]">{{
                    errors[0]
                  }}</trac-input-error>
                </trac-validation-provider>

                <trac-validation-provider
                  name="email"
                  rules="required|email"
                  v-slot="{ errors }"
                >
                  <trac-input
                    v-model.trim="user.email"
                    ref="emails"
                    type="email"
                    placeholder="Email"
                  ></trac-input>
                  <trac-input-error v-if="errors[0]">{{
                    errors[0]
                  }}</trac-input-error>
                </trac-validation-provider>

                <trac-validation-provider
                  name="phone number"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <trac-input
                    v-model="user.phone"
                    type="number"
                    placeholder="Phone Number"
                    ref="phone number"
                  ></trac-input>
                  <trac-input-error v-if="errors[0]">{{
                    errors[0]
                  }}</trac-input-error>
                </trac-validation-provider>
              </div>
              <div class="flex justify-end items-end mt-10">
                <trac-button type="submit" variant="outline"> Next</trac-button>
              </div>
            </form>
          </trac-validation-observer>
        </div>
      </div>
    </main>
    <main v-show="!userForm" class="mt-6">
      <div>
        <h2
          @click="userForm = true"
          class="text-xs cursor-pointer flex items-center"
        >
          <svg
            class="mr-2 w-3 mb-px h-3"
            viewBox="0 0 8 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M7.00195 1.00147L1.00195 7.00147L7.00195 13.0015"
              stroke="#013E9E"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          Settings
        </h2>
        <h1 class="font-medium mt-2">Employee details</h1>
        <div class="mt-6 bg-white grid md:flex w-full white-gradient px-8 py-6">
          <!-- <div>
            <div class="w-64 bg-gray-400 h-56 rounded-tl-sm rounded-tr-sm">
              <img v-if="false" class="w-full h-full object-cover" alt="" />
            </div>
            <div
              class="
                w-64
                flex
                items-center
                justify-center
                py-3
                cursor-pointer
                bg-gray-500
                text-sm text-white
              "
            >
              Add Picture
            </div>
          </div> -->
          <div class="md:pl-10 w-full">
          <!-- <div class="md:ml-10 md:pl-10 w-full md:border-l"> -->
            <trac-custom-header>
              <template slot="leading">Select</template>
              <template slot="trailing"> Store(s)</template>
            </trac-custom-header>
            <div class="grid items-center overflow-x-scroll">
              <!-- <div class="text-sm">Select Store(S)</div> -->
              <div class="md:ml-6 flex flex-wrap gap-x-4 md:grid grid-cols-5 gap-5 overflow-scroll">
                <div v-for="store in stores" :key="store.id || store._id">
                   <div class="mt-4">
                      <trac-checkbox
                        class=""
                        @check="selectUserStore"
                        :isChecked="
                          selectedStores.includes(store.name.toLowerCase())
                        "
                        :value="store"
                        ><p class="text-sm pl-2 capitalize whitespace-no-wrap">{{
                          store.name
                        }}</p></trac-checkbox
                      >
                    </div>
                </div>
              </div>
            </div>
            <div class="mt-10">
              <div class="border relative p-4 rounded">
                <div
                  class="absolute top-0 -mt-2 left-0 ml-2 bg-white px-2 text-sm"
                >
                  Roles
                </div>
                <div class="mt-2 flex items-center">
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle
                      cx="8.16267"
                      cy="8.16267"
                      r="7.16267"
                      stroke="#253B95"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M17.1164 17.1164L13.2217 13.2217"
                      stroke="#253B95"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  <!-- <div
                    class="ml-3 text-primaryBlue w-56 text-sm uppercase font-medium"
                  >
                    <trac-input
                      v-model="search"
                      placeholder="Search Role"
                    ></trac-input>
                  </div> -->
                </div>
                <div class="mt-5 w-64">
                  <trac-dropdown
                    title="Select Role"
                    class="w-full"
                    :menuItems="filteredRoles"
                    v-model="user.role"
                  >
                    {{ filteredRoles.role }}</trac-dropdown
                  >
                </div>
                <!-- <div class="mt-4">
                  <trac-button variant="outline">New Role</trac-button>
                </div> -->
              </div>

              <div></div>
            </div>
            <div class="flex justify-end items-end mt-10">
              <trac-button @click.native="open"> Save Changes</trac-button>
            </div>
          </div>
        </div>
      </div>
    </main>
    <trac-confirmation
      @close="confirmation = $event"
      :type="type"
      :active="confirmation"
    >
      {{ message }}
    </trac-confirmation>
  </main>
</template>

<script>
import {
  ADD_DATA_TO_DB,
  CONNECT_TO_DB,
  GET_DB_DATA,
} from "../../browser-db-config/indexedDB";
import { GET_USER_DATA } from "../../browser-db-config/localStorage";

export default {
  data() {
    return {
      isLoading: false,
      stores: [],
      selectedStores: [],
      roles: [],
      search: "",
      confirmation: null,
      type: null,
      message: null,
      userForm: true,
      userDetail: null,
      id: null,
      user: {
        first_name: "",
        last_name: "",
        role: "",
        phone: "",
        email: "",
        stores: [],
      },
    };
  },
  computed: {
    filteredRoles() {
      return this.roles.filter((user) =>
        user.name.toLowerCase().includes(this.search.trim().toLowerCase())
      );
    },
  },
  methods: {
    async fetchAllStores() {
      this.isLoading = true;
      await this.$store.dispatch("FETCH_ALL_STORES");
      const res = this.$store.getters["GET_ALL_STORES"];

      if (res.status) {
        this.stores = res.data || [];
      }
      this.isLoading = false;
    },
    hideUserForm() {
      this.userForm = false;
    },
    async open() {
      if (this.user.role === "") {
        this.message = "Please add a role";
        this.confirmation = true;
        this.type = false;
        return;
      }
      if (this.user.stores.length === 0) {
        this.message = "Please add one or more stores.";
        this.confirmation = true;
        this.type = false;
        return;
      }

      this.isLoading = true;

      let res = await this.$store.dispatch("UPDATE_USER", {
        ...this.user,
        _id: this.id,
      });

      if (res.status) {
        this.message = `User Updated Successfully`;
        this.confirmation = true;
        this.type = true;

        // this.$router.push({ name: "UserSettings" });
        this.$router.back();
      }

      this.isLoading = false;
    },
    selectUserStore(e) {
      if (e.checked) {
        this.user.stores.push(e.value);
      } else {
        this.user.stores = this.user.stores.filter(
          (store) => store.name.toLowerCase() !== e.value.name.toLowerCase()
        );
      }
    },
  },
  async mounted() {
    await this.fetchAllStores();
    // this.stores = GET_USER_DATA().stores.map((store) => ({
    //   name: store.name,
    //   id: store.id || store._id,
    // }));

    let res = await this.$store.dispatch("FETCH_ALL_ROLES");
    let k = res.data ? res.data : [];
    let u = k.map((x) => ({ name: x.role }));
    this.roles = u;
  },
  async created() {
    this.userDetail = this.$store.state.miscellaneous.userDetails;
    this.id = this.userDetail._id;
    this.user.first_name = this.userDetail.first_name;
    this.user.last_name = this.userDetail.last_name;
    this.user.email = this.userDetail.email;
    this.user.phone = this.userDetail.phone;
    this.user.role = this.userDetail.role;
    let customStore = (this.userDetail.stores || []).map((store) => ({
      name: store.name,
      id: store.id || store._id,
    }));
    this.selectedStores = customStore.map((s) => s.name.toLowerCase());
    this.user.stores = customStore;
  },
};
</script>

<style></style>
